import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { AngularImageViewerModule } from "@clarivate/angular-image-viewer";
import { SharedModule } from "@shared";
import { NzCollapseModule } from "ng-zorro-antd/collapse";

import { ProfileRoutingModule } from "./profile-routing.module";
import { ProfileComponent } from "./profile.component";
import { UserProfileComponent } from './user-profile/user-profile.component';
import { SecretKeyGeneratorComponent } from './secret-key-generator/secret-key-generator.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { BioDataComponent } from './bio-data/bio-data.component';
import { UserIdentificationComponent } from './user-identification/user-identification.component';
import { InstitutionDetailComponent } from './institution-detail/institution-detail.component';
import { CountrySetupComponent } from './country-setup/country-setup.component';
import { NzInputNumberModule } from "ng-zorro-antd/input-number";

@NgModule({
  declarations: [ProfileComponent, UserProfileComponent, SecretKeyGeneratorComponent, ChangePasswordComponent, DeleteAccountComponent, BioDataComponent, UserIdentificationComponent, InstitutionDetailComponent, CountrySetupComponent],
  imports: [
    CommonModule,
    ProfileRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    AngularImageViewerModule,
    NzCollapseModule,
    NzInputNumberModule,
    NzCollapseModule
],
})
export class ProfileModule {}
